export default "__VITE_ASSET__BVniyP4a__"